export default class ReducerInjector {
    constructor(initialReducers = {}) {
        this.reducers = { ...initialReducers };
        this.emitChange = null;
    }

    inject(newReducers) {
        this.reducers = { ...this.reducers, ...newReducers };
        if (this.emitChange) {
            this.emitChange(this.reducers);
        }
    }

    getReducers() {
        return this.reducers;
    }

    setChangeListener(listener) {
        if (this.emitChange) {
            // eslint-disable-next-line no-console
            console.log('ReducerInjector: Change listener already present - overriding');
        }
        this.emitChange = listener;
    }
}
